import axios from "axios";
import wazzupApi from "../wazzupApi";

const axiosInstance = axios.create({
  baseURL:
    "https://clients.amoapi.ru/products/products.managers_activity_panel_copy",
  timeout: 60000,
});

const API_TIMEOUTS = {
  "/getSettings": 60000,
  "/getDepartmentsManagers": 60000,
  "/getEventTypes": 60000,
  "/getData": 60000,
};

let settingsTimezone = "Europe/Moscow";
let crmMessageTypeIds = new Set([0, 89, 90]);

const getAuthParams = () => {
  const params = new URLSearchParams(window.location.search);

  return {
    accountId: Number(params.get("c")) || null,
    password: params.get("p") || null,
  };
};

const requestBackend = async (api, query = {}) => {
  const authParams = getAuthParams();

  if (!authParams.accountId || !authParams.password) {
    throw new Error("Нет параметров доступа. Открой панель с ?c=ACCOUNT_ID&p=PASSWORD");
  }

  const response = await axiosInstance.post(
    api,
    {
      ...authParams,
      ...query,
    },
    {
      timeout: API_TIMEOUTS[api] || 60000,
    }
  );

  return response.data;
};

const getWazzupAuth = () => ({
  provider: "amo",
  ...getAuthParams(),
});

const isMessageType = (eventType = {}) => {
  const title = [
    eventType.title,
    eventType.titleRU,
    eventType.titleEN,
    eventType.name,
  ]
    .filter(Boolean)
    .join(" ");

  return /(сообщ|message|переписк|correspondence)/i.test(title);
};

export default {
  provider: "amo",

  getStorageScope() {
    return getAuthParams().accountId || "amo";
  },

  async getLookup() {
    const [usersByDeps, rawEventTypes] = await Promise.all([
      requestBackend("/getDepartmentsManagers"),
      requestBackend("/getEventTypes"),
    ]);
    const eventTypes = Array.isArray(rawEventTypes) ? [...rawEventTypes] : [];
    const discoveredMessageTypes = eventTypes
      .filter(isMessageType)
      .map((eventType) => Number(eventType.typeId ?? eventType.id))
      .filter(Number.isFinite);

    crmMessageTypeIds = new Set([0, 89, 90, ...discoveredMessageTypes]);

    if (!eventTypes.some((eventType) => Number(eventType.typeId ?? eventType.id) === -2)) {
      eventTypes.push({
        typeId: -2,
        titleRU: "Переписка Wazzup",
        titleEN: "wazzup_correspondence",
      });
    }

    return {
      usersByDeps,
      eventTypes,
    };
  },

  async getDayEvents(day, query = {}) {
    const [crmEvents, wazzupData] = await Promise.all([
      requestBackend("/getData", query),
      wazzupApi.getDaySafe(getWazzupAuth(), day, settingsTimezone),
    ]);

    return wazzupApi.mergeDayEvents({
      crmEvents,
      wazzupData,
      isCrmMessageEvent: (event) => crmMessageTypeIds.has(Number(event.typeId)),
    });
  },

  async getSettings() {
    const settings = await requestBackend("/getSettings");
    settingsTimezone = settings.timezone || settingsTimezone;
    return settings;
  },

  async getPortalStatus() {
    return {
      ok: true,
      provider: "amo",
      scope: this.getStorageScope(),
    };
  },

  getWazzupConfig(options) {
    return wazzupApi.getConfig(getWazzupAuth(), options);
  },

  connectWazzup(apiKey) {
    return wazzupApi.connect(getWazzupAuth(), apiKey);
  },

  saveWazzupMappings(mappings) {
    return wazzupApi.saveMappings(getWazzupAuth(), mappings);
  },
};
